import { Image, Text, Flex } from '@chakra-ui/react'
import React from 'react'
import CheckboxGroup from '_app/components/Form/CheckboxGroup'
import { AttributeOption } from '_app/graphql/generated/graphql'
import { NotNull } from '_app/types'
import { AggregationOption } from '_app/types/api'

interface FilterItemsListProps {
  requestVar: string;
  items: NotNull<AggregationOption>[];
  swatches?: AttributeOption[];
}

const FilterItemsList = ({
  requestVar,
  items = [],
  swatches = [],
}: FilterItemsListProps) => {
  const options = items.map(item => {
    const img = swatches.find(
      swatch => swatch?.label?.toLowerCase() === item.label.toLowerCase()
    )?.image

    const label = (
      <Flex
        display="inline-flex"
        alignItems="center"
        gap="8px"
        height="16px"
        mt="-1px"
      >
        {img && requestVar !== 'rozmiar_swatch' ? (
          <Image display="inline" boxSize="16px" src={img} alt="" />
        ) : (
          <Text height="16px" />
        )}
        <Text
          as="span"
          whiteSpace="nowrap"
          overflow="hidden"
          textOverflow="ellipsis"
          fontWeight={300}
          lineHeight={1}
        >
          {item.label}
        </Text>
      </Flex>
    )

    return {
      value: item.value,
      label,
    }
  })

  return (
    <CheckboxGroup
      name={`${requestVar}`}
      options={options}
      optionProps={{
        mb: '18px',
        display: 'flex',
        alignItems: 'center',
      }}
    />
  )
}

export default FilterItemsList
